"use client";

import React from "react";
import { LanguageProvider } from "./LanguageProvider";

type ProvidersProps = {
  locale?: string;
  children: React.ReactNode;
};

export const Providers: React.FC<ProvidersProps> = ({
  locale = "en",
  children,
}) => {
  return <LanguageProvider locale={locale}>{children}</LanguageProvider>;
};

// HOC to wrap any component with the collection of providers.
export const wrapWithProviders = <P extends object>(
  Component: React.ComponentType<P>
) => {
  const Wrapped: React.FC<P & { locale?: string }> = ({ locale, ...props }) => {
    return (
      <Providers locale={locale}>
        <Component {...(props as P)} />
      </Providers>
    );
  };

  Wrapped.displayName = `wrapWithProviders(${
    Component.displayName || Component.name || "Component"
  })`;
  return Wrapped;
};
